module.exports = __webpack_public_path__ + "img/ic_nav_star-active.7fbacb9a.svg";